import Navigation from "./modules/Navigation";
import {Carousels} from "./modules/Carousels";
import {Accordion, SwitchableTabs} from "./modules/Accordion";
import {YouTubeEmbed} from "./modules/YoutubeVideo";
import {toggleMiniCart} from "./modules/SideCart";

new Navigation();
toggleMiniCart();
YouTubeEmbed();
Accordion();
SwitchableTabs({
    sections: '.switchable-content',
    content: '.switchable-content__text',
    buttons: '.switchable-content__tab'
});

SwitchableTabs({
    sections: '.switchable-rich-content',
    content: '.switchable-rich-content__text',
    buttons: '.switchable-rich-content__button'
});


Carousels('.mp-main-slider__slides', {
    perPage: 1,
    rewind: true,
    arrows: false,
    mediaQuery: 'min',
    rewindByDrag: true,
    type: 'fade',
    speed: 1200,
    pagination: true,
    navigation: true,
    breakpoints: {
        1800: {
            arrows: true
        }
    },
})

Carousels('.mp-gallery-slider', {
    perPage: 1,
    rewind: true,
    arrows: false,
    mediaQuery: 'min',
    rewindByDrag: true,
    type: 'slide',
    speed: 1200,
    pagination: true,
    navigation: true,
    breakpoints: {
        1800: {
            arrows: true
        }
    },
})


Carousels('.popular-products__carousel', {
    perPage: 1,
    omitEnd: true,
    easing: 'cubic-bezier(0.25, 1, 0.5, 1)',
    gap: 25,
    mediaQuery: "min",
    arrows: false,
    pagination: true,
    breakpoints: {
        1000: {
            perPage: 4,
            pagination: false
        },
        600: {
            perPage: 3
        },
    },
})

Carousels('.popular-products__carousel', {
    perPage: 1,
    omitEnd: true,
    easing: 'cubic-bezier(0.25, 1, 0.5, 1)',
    gap: 25,
    mediaQuery: "min",
    arrows: false,
    pagination: true,
    breakpoints: {
        1000: {
            perPage: 4,
            pagination: false
        },
        600: {
            perPage: 3
        },
    },
})

Carousels('.related-products-carousel', {
    perPage: 1,
    easing: 'cubic-bezier(0.25, 1, 0.5, 1)',
    gap: 25,
    mediaQuery: "min",
    pagination: true,
    navigation: true,
    arrows: false,
    breakpoints: {
        1000: {
            arrows: true,
            perPage: 4,
            pagination: false
        },
        600: {
            perPage: 3
        },
    },
})

Carousels('.switchable-content__carousel', {
    perPage: 2,
    omitEnd: true,
    easing: 'cubic-bezier(0.25, 1, 0.5, 1)',
    gap: 5,
    mediaQuery: "min",
    arrows: true,
    pagination: true,
    breakpoints: {
        765: {
            destroy: true
        },
    },
})


const mapiToggleLinks = function () {
    const contentWrapper = $('.mp-main-slider__content');

    const toggleBtn = contentWrapper.find('.mp-main-slider__toggle');
    const links = contentWrapper.find('.mp-main-slider__links-wrap__inner');

    toggleBtn.on('click', function () {
        $(this).find('svg').toggleClass('rotate-180')
        links.slideToggle();

    });

};

mapiToggleLinks();


function mapiScrollToTop() {
    $('.return-to-top').on('click', function (e) {
        e.preventDefault();
        $("body,html").animate({
            scrollTop: 0
        }, 500)
    });
}

mapiScrollToTop();